import { useRoutes } from 'react-router-dom';
import routes from './routes';
import StagingGate from './app/components/StagingGate';

const App = (props: any) => {
  const element = useRoutes(routes)
  return (
    <StagingGate>{element}</StagingGate>
  )
}

export default App;
